import { IDB_rowRead, IDB_rowsDelete, IDB_rowsReadAll, IDB_rowsWrite, IDB_rowWrite } from './IDB.queries'
import { IDB_globalDb } from './IDB'
import type { Type_IUnitList } from '../Type/Type.hive'

export function IDB_unitListRead(id: number) {
    return IDB_rowRead<Type_IUnitList>(IDB_globalDb, 'unit_lists', id)
}

export function IDB_unitListsDelete(ids: number[]) {
    return IDB_rowsDelete(IDB_globalDb, 'unit_lists', ids)
}

export function IDB_unitListsReadAll() {
    return IDB_rowsReadAll<Type_IUnitList>(IDB_globalDb, 'unit_lists')
}

export function IDB_unitListsWrite(unitLists: Type_IUnitList[]) {
    return IDB_rowsWrite(IDB_globalDb, 'unit_lists', unitLists)
}

export function IDB_unitListWrite(unitList: Type_IUnitList) {
    return IDB_rowWrite(IDB_globalDb, 'unit_lists', unitList)
}
